module.exports = __webpack_public_path__ + "static/media/wechat.8656f956.jpg";